import clsx from 'clsx'
import { toAbsoluteUrl} from '../../../helpers'
import { HeaderUserMenu} from '../../../partials'
import { ThemeModeSwitcher } from '../../../partials'
import { DemoModal } from '../../../../app/Modal_Demo/ViewModalDemo'
import { useAuth } from '../../../../app/modules/auth'
import { useState } from 'react'
type ID = undefined | null | number

const itemClass = 'ms-1 ms-lg-3'
/*const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'*/
const userAvatarClass = 'symbol-35px symbol-md-40px'
/*const btnIconClass = 'fs-1'*/

const Navbar = () => {
  const{currentUser}= useAuth()
  const [ ID , setID]=useState<ID>(undefined)


  /*const {config} = useLayout()*/
  return (
    <div className='app-navbar flex-shrink-0'>
      {/*<div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
  </div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
        </div>*/}

     {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>*/}

      {/*<div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
    </div>*/}

    {/*<div className={clsx('app-navbar-item', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
  </div>*/}

      <div className={clsx('app-navbar-item', itemClass)}>
        {currentUser?.is_demo===true&& <span className="badge badge-success" style={{marginRight:'10px'}} onClick={ () => setID(null)} >
        <svg height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="5"/><circle cx="10.5" cy="10.5" fill="currentColor" r="3"/></g></svg>
          Live Demo
        </span>}

        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
            <img src="/media/iconos_v2/Accounts.svg" alt="user" style={{width:'35px'}} />
       
        </div>

        <HeaderUserMenu />

      </div>

      {/*config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )*/}
            {ID !== undefined && <DemoModal setID={setID} id={ID} />}

    </div>
  )
}

export {Navbar}
